import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Renders `component` with the v5-style `history` and `location` props
 * that react-router v6 no longer injects into route components.
 */
export default function WithRouterProps({ component: Component, ...props }) {
	const navigate = useNavigate();
	const location = useLocation();
	const history = useMemo(
		() => ({
			push: to => navigate(to),
			replace: to => navigate(to, { replace: true }),
			goBack: () => navigate(-1),
			location
		}),
		[navigate, location]
	);
	return <Component {...props} history={history} location={location} />;
}
